interface ComingSoonCardProps {
  /** Optional subtitle, e.g. "Stories tracking" */
  label?: string;
}

export default function ComingSoonCard({ label }: ComingSoonCardProps) {
  return (
    <div className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card">
      <div className="flex min-h-[16rem] flex-col items-center justify-center px-6 py-12 text-center sm:min-h-[18rem]">
        <div className="grid h-12 w-12 place-items-center rounded-full bg-rose-softer text-rose-deep">
          <svg
            className="h-5 w-5"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
        </div>
        <p className="mt-4 font-display text-[18px] font-extrabold text-ink sm:text-[20px]">
          Stay tuned, coming soon!
        </p>
        {label ? (
          <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-muted">{label}</p>
        ) : null}
      </div>
    </div>
  );
}
